// Store
import store from '@/store/index'
// Services
import OrdensServicoService from "@/services/Registros/OrdensServicoService"
import RecibosService from '@/services/Registros/RecibosService'
import CustasService from "@/services/Registros/CustasService"

// Entities
import OrdemServico from "./OrdemServico"

// Outros
import moment from 'moment'

export class useCaseOrdemServico {
  constructor (ordemServico) {
    this.ordemServico = ordemServico || null
  }
  async getById (id) {
    if (!id) {
      throw Error('O ID da Ordem de Serviço deve ser informado')
    }

    const os = await OrdensServicoService.showOS(id || this.ordem_servico_id)
    return new OrdemServico(os)
  }

  async create () {
    if (!this.ordemServico) {
      throw Error('Nenhuma Ordem de Serviço foi passada para criação')
    } 

    this.ordemServico.existeSelo = !!this.ordemServico.itens.find(item => item.seloStatus)
    // Atualiza o valor da OS antes de salvar
    this.ordemServico.valorTotal()
    const newOs = await OrdensServicoService.storeOS(this.ordemServico)
    return new OrdemServico(newOs)
  }

  async update () {
    if (!this.ordemServico) {
      throw Error('Nenhuma ordem de serviço foi passada para atualização')
    }
    const os = await OrdensServicoService.updateOS(this.ordemServico, this.ordemServico.ordem_servico_id)
    return new OrdemServico(os)
  }

  async delete () {
    // Não realiza de fato a exclusão, apenas cancela não sendo mais visivel ao usuario
    if (!this.ordemServico) {
      console.error("Ordem de serviço não instancia na classe UseCaseOrdemServico para exclusão!")
    }

    if (this.ordemServico.getExisteSelosAtivos()) {
      throw Error('Esta OS possui selos. Para excluir a OS, verifique os itens dentro dela.')
    } else {
        try {
          this.ordemServico.cancelada = true,
          this.ordemServico.data_cancelamento = moment().format('YYYY-MM-DD')
          await OrdensServicoService.updateOS(this.ordemServico, this.ordemServico.ordem_servico_id)
        } catch (e) {
          throw Error('Não foi possível excluir essa ordem de serviço. Tente novamente.')
        }   
    }
  }

  async excluirPermanentemente () {
    const osExcluida = await OrdensServicoService.destroyOS(this.ordemServico.ordem_servico_id)
    return osExcluida
  }

  async imprimirRecibo (tipoRegistro, registro, data) {
    const itensInvalidos = this.ordemServico.itens.filter(item => item.flag_cancelado)

    if (!this.ordemServico.itens || !this.ordemServico.itens.length) {
      return displayMessage('error', 'Adicione itens na O.S para poder imprimir o recibo.')
    }


    if (itensInvalidos.length > 0) {
      displayMessage('error', '', 'Os itens da ordem de serviço não são válidos para o recibo.')

      setTimeout(() => {
        const btnCancel = document.querySelector('.swal2-cancel')

        if (btnCancel) btnCancel.focus()
      }, 200)

      return
    }

    const switchType = {
      obito: RecibosService.reciboObito,
      nascimento: RecibosService.reciboNascimento,
      habilitacao: RecibosService.reciboCasamento,
      casamento: RecibosService.reciboCasamento
    }

    const emolumentos = await this.getEmolumentos(this.ordemServico.itens)

    const payload = {
      registro,
      data,
      os: this.ordemServico,
      cartorio: store.state.auth.cartorioObj,
      custas: this.ordemServico.itens,
      emolumentos: emolumentos
    }

    try {
      loader({ text: 'Aguarde...', active: true })

      if (tipoRegistro && registro && data) {
        const url = await switchType[tipoRegistro](payload)       
        return url
      }

      const url = await RecibosService.reciboSemRegistro(payload)
      return url
    } catch (e) {
      displayMessage('error', '', 'Não foi possível imprimir o recibo da ordem de serviço. Tente novamente.')

      setTimeout(() => {
        const btnCancel = document.querySelector('.swal2-cancel')

        if (btnCancel) btnCancel.focus()
      }, 200)
    } finally {
      loader({ text: '', active: false })
    }
  }
  
  async getEmolumentos () {
    let emolumentos = []
    let valor = null
    let custas 

    const custasList = await CustasService.getCustas({
      cartorio_id: this.ordemServico.cartorio_id,
      perPage: 100,
      os: 1,
      ativo: true
    })

    custas = custasList.data

    this.ordemServico.itens.forEach(item => {
      const { custa, averbacao, quantidade } = item

      custa.itens.forEach(custaItem => {
        const emolumentoIndex = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)

        if (averbacao > 0) {
          const custaAverbacaoItem = custas.find(custaIss => custaIss.codigo === 12)
          const destinatario = custaAverbacaoItem.itens.filter(custa => custa.destino == custaItem.destino)
          valor = (custaItem.valor * quantidade) + (destinatario[0].valor * averbacao)
        } else {
          valor = (custaItem.valor * quantidade)
        }            

        if (emolumentoIndex >= 0) {
          emolumentos[emolumentoIndex].valor += item.valor > 0 ? valor : 0
        } else {
          emolumentos.push({
            destino: custaItem.destino,
            valor: item.valor > 0 ? valor : 0
          })
        }
      })
    })

    emolumentos.push({
      destino: 'total',
      valor: emolumentos.map((e) => e.valor).reduce((a, b) => a + b, 0)
    })

    return emolumentos
  }
}